import React from 'react'

import BuildConfig from '$extensionSrc/buildConfig'
import ActionButton, {
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'
import ImpressionLogger from '$extensionSrc/components/ImpressionLogger'
import LogContextProvider from '$extensionSrc/components/LogContextProvider'
import somethingWentWrong from '$tenantSrc/something-went-wrong.png'
import somethingWentWrong2x from '$tenantSrc/something-went-wrong@2x.png'
import somethingWentWrong3x from '$tenantSrc/something-went-wrong@3x.png'

import styles from './NoReport.module.scss'

export default function NoReport({ onClickCta }: { onClickCta?: () => void }) {
  return (
    <LogContextProvider component="NoReport">
      <ImpressionLogger eventName="component:render" eventProps={{}}>
        <div className="NoReport">
          <img
            className={styles.illustration}
            srcSet={
              `${somethingWentWrong} 1x, ` +
              `${somethingWentWrong2x} 2x, ` +
              `${somethingWentWrong3x} 3x`
            }
            alt="Something went wrong"
          />
          <div className={styles.content}>
            <div className={styles.text}>
              <div className="heading1 bold">
                Your {BuildConfig.TENANT_NAME} report is waiting...
              </div>
              <div className="body1">
                Start your first checklist and begin cleanup to generate your
                personalized report. See what's secure, what's still exposed,
                and what you can do next to stay protected.
              </div>
            </div>
            <ActionButton
              size={ActionButtonSize.MEDIUM}
              type={ActionButtonType.PRIMARY}
              onClick={onClickCta}
            >
              Get started
            </ActionButton>
          </div>
        </div>
      </ImpressionLogger>
    </LogContextProvider>
  )
}
